import React, { useState } from 'react';

const PasswordInput = ({
  value,
  onChange,
  onKeyPress,
  placeholder = 'Enter password',
  disabled = false,
  label,
  id,
  style = {},
  labelStyle = {},
  containerStyle = {},
  showIcon = '👁️',
  hideIcon = '👁️‍🗨️',
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const defaultInputStyle = {
    width: '100%',
    padding: '10px 40px 10px 38px',
    borderRadius: '6px',
    border: '1px solid #d1d5db',
    fontSize: '14px',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    background: '#f9fafb',
    color: '#1f2937',
  };

  const defaultLabelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '8px',
    color: '#374151',
  };

  const defaultContainerStyle = {
    marginBottom: '16px',
    position: 'relative',
  };

  const toggleButtonStyle = {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#6b7280',
    fontSize: '18px',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const lockIconStyle = {
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#9ca3af',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={{ ...defaultContainerStyle, ...containerStyle }}>
      {label && <label htmlFor={id} style={{ ...defaultLabelStyle, ...labelStyle }}>{label}</label>}
      <div style={{ position: 'relative', width: '100%' }}>
        <span style={lockIconStyle}>🔒</span>
        <input
          id={id}
          name="password"
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          style={{ ...defaultInputStyle, ...style }}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          style={toggleButtonStyle}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? showIcon : hideIcon}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
